import { encodeParams, makeActionCreator, selectObjectKeys } from "../../../utils";
import { ordersListFiltersSelector } from "./filtersActions";
import { stringify as stringifyQueryString } from "querystring";
import { toast } from "react-toastify";
import { apiFetch } from "../../../actions/apiActions";
import { push } from "react-router-redux";

export const DATA_LOADED = "CLIENT_PANEL.ORDERS_LIST.RESULTS.DATA_LOADED";
export const IS_LOADING_CHANGED = "CLIENT_PANEL.ORDERS_LIST.RESULTS.IS_LOADING_CHANGED";
export const LAST_FILTERS_UPDATE_CHANGED = "CLIENT_PANEL.ORDERS_LIST.RESULTS.LAST_FILTERS_UPDATE_CHANGED";

export const dataLoaded = makeActionCreator(DATA_LOADED, "totalRows", "payload");
export const isLoadingChanged = makeActionCreator(IS_LOADING_CHANGED, "payload");
export const lastFiltersUpdateChanged = makeActionCreator(LAST_FILTERS_UPDATE_CHANGED, "payload");

export let requestCache = {}; // this global variable holds the request cache for prefetching and faster response times

export function loadRowsDebounced() {
    return async (dispatch, getState) => {
        const old = new Date().toString();
        dispatch(lastFiltersUpdateChanged(old));
        setTimeout(() => {
            if (getState().clientPanel.customerOrdersList.results.lastFiltersUpdate === old) {
                dispatch(loadRows());
            }
        }, 400);
    };
}

export function loadRows() {
    return async (dispatch, getState) => {
        const filters = ordersListFiltersSelector(getState());
        dispatch(isLoadingChanged(true));
        try {
            const data = await dispatch(fetchPage(filters.page));
            if (!data) return;
            // we can prefetch the next page
            dispatch(fetchPage(filters.page + 1));

            dispatch(dataLoaded(data.totalRows, data.rows));
        } catch (e) {
            console.error(e);
            toast("Failed to load orders: " + e.message, { type: "error" });
        }
    };
}

export function fetchPage(page) {
    return async (dispatch, getState) => {
        const filters = ordersListFiltersSelector(getState());
        const requestUrl =
            `/api/orders-list?` +
            stringifyQueryString({
                page,
                sortBy: filters.sortBy,
                rowsPerPage: filters.rowsPerPage,
                selectedFilter: filters.selectedFilter,
                dateRange: JSON.stringify(filters.dateRange),
                searchContent: filters.searchContent,
                period: filters.period,
                condition: "customerPanelVisible",
                enabledColumns: [
                    "orderNumber",
                    "officialOrderName",
                    "closedAt",
                    "startDate",
                    "customer",
                    "location",
                    "partNames",
                    "partNumbers",
                    "finished"
                ]
            });
        if (!requestCache[requestUrl]) {
            requestCache[requestUrl] = (async () => {
                const resp = await dispatch(apiFetch(requestUrl, {}));
                const data = await resp.json();
                if (!resp.ok) {
                    throw new Error(data.message);
                }
                return data;
            })().catch(e => {
                console.error("failed to prefetch next page:", e);
                toast("Failed to fetch page: " + e.message, { type: "error" });
                delete requestCache[requestUrl];
            });
        }
        return requestCache[requestUrl];
    };
}

export function getDetailsURL(orderId, state) {
    const filters = ordersListFiltersSelector(state);
    return (
        encodeParams`/customer/${orderId}?` +
        stringifyQueryString({
            ...selectObjectKeys(filters, ["selectedFilter", "period"]),
            dateRange: JSON.stringify(filters.dateRange)
        })
    );
}

export function goToOrder(orderId) {
    return async (dispatch, getState) => {
        const { dateRange } = ordersListFiltersSelector(getState());
        dispatch(push(getDetailsURL(orderId, getState())));
    };
}
